import { initDesignPhotoSlideShows } from '../components/DesignPhotoSlideshow';
import QuickViewModal from '../components/QuickViewModal';

document.addEventListener('DOMContentLoaded', () => {
  initDesignPhotoSlideShows();

    const quickviewModal = QuickViewModal('js-quickview-modal');

});
